import { API_ROUTES } from '@/constants/apiRoutes';
import {
  LoanRequestDetailsResponse,
  LoanRequestResponse,
} from '@/types/lending';
import { api } from '@/utils/api';

export const getLendingList = async (queryParams: string) => {
  const { data } = await api<LoanRequestResponse>({
    url: `${API_ROUTES._LENDING}?${queryParams}`,
    method: 'get',
  });

  return data;
};

export const getLendingDetails = async (uuid: string) => {
  const { data } = await api<LoanRequestDetailsResponse>({
    url: `${API_ROUTES._LENDING}${uuid}`,
    method: 'get',
  });

  return data;
};
